<template>
  <div class="grid-cell">
    <el-tooltip v-if="!editMode && !showInput && editable"
                :placement="toolTipPlacement"
                :open-delay="toolTipDelay"
                :content="toolTipContent">
      <div @click="onFocus" tabindex="0"
           :class="{editable: editable}"
           class="grid-cell__content"
           @keyup.enter="onFocus">
        <slot></slot>
      </div>

    </el-tooltip>
    <div v-if="!editable"
         @click="onFocus"
         tabindex="0"
         class="grid-cell__content"
         @keyup.enter="onTextFocus">
      <slot></slot>
    </div>
    <slot name="editable-component" v-bind="componentData">
      <component :is="editableComponent"
                 class="grid-cell__component"
                 v-if="editMode || showInput"
                 ref="input"
                 @blur="onBlur"
                 @focus="onFocus"
                 @keyup.enter.native="onBlur"
                 v-on="$listeners"
                 v-bind="$attrs"
                 :value="value"
                 @input="onInputChange">
      </component>
    </slot>
    <slot name="after"></slot>
  </div>
</template>
<script>
  export default {
    name: 'editable-grid-cell',
    inheritAttrs: false,
    props: {
      value: {
        type: [String, Boolean, Object, Number],
        default: ''
      },
      toolTipContent: {
        type: String,
        default: 'Click to edit'
      },
      toolTipDelay: {
        type: Number,
        default: 500
      },
      toolTipPlacement: {
        type: String,
        default: 'top-start'
      },
      showInput: {
        type: Boolean,
        default: false
      },
      editable: {
        type: Boolean,
        default: true
      },
      editableComponent: {
        type: String,
        default: 'fg-input'
      }
    },
    computed: {
      componentData() {
        return {
          showComponent: this.editMode || this.showInput,
          ref: 'input',
          onInputChange: this.onInputChange,
          onBlur: this.onBlur,
          onFocus: this.onFocus
        };
      }
    },
    data() {
      return {
        editMode: false
      };
    },
    methods: {
      onFocus() {
        this.$emit('focus');
        if (!this.editable) {
          return;
        }
        this.editMode = true;
        this.$nextTick(() => {
          let input = this.$refs.input;
          if (input && input.focus && typeof input.focus === 'function') {
            input.focus();
          }
        });
      },
      onBlur() {
        this.editMode = false;
        this.$emit('blur');
      },
      onInputChange(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
<style lang="scss" scoped>
  .grid-cell__content {
    cursor: default;
    &.editable {
      cursor: pointer;
    }
  }

  .grid-cell__content,
  .grid-cell__component {
    height: 40px;
    line-height: 40px;
  }
</style>
